<template>
  <div >
    <table>
      <tr>
        <td>Date</td>
        <td>{{ reportDesc.date }}</td>
      </tr>

      <tr>
        <td>Provider</td>
        <td class="text-capitalize">
          <router-link :to="{ name: 'ProviderNavigation', params: { specialty: getSpecialtyLink(providerSpecialty), id: providerId } }">
            {{ providerFullName }}
          </router-link>
        </td>
      </tr>

      <!--<tr>-->
        <!--<td>NPI</td>-->
        <!--<td>{{ reportDesc.npi }}</td>-->
      <!--</tr>-->

      <tr>
        <td>Specialties</td>
        <td>
          <ul>
            <li v-for="(specialty, index) in reportDesc.provider.specialties" :key="index">
              {{ specialty.name }}
            </li>
          </ul>
        </td>
      </tr>

      <tr>
        <td>Document type</td>
        <td>{{ reportDesc.documentType }}</td>
      </tr>

      <tr v-if="reportDesc.procedure">
        <td>Procedure</td>
        <td>{{ reportDesc.procedure }}</td>
      </tr>
    </table>
  </div>
</template>
<script>

export default {
  name: 'report-desc',
  props: {
    reportDesc: Object
  },
  computed: {
    providerFullName: function () {
      // console.log(this.reportDesc)
      return this.reportDesc.provider.firstName.toLowerCase() + ' ' + this.reportDesc.provider.middleName + ' ' + this.reportDesc.provider.lastName.toLowerCase();
    },
    providerSpecialty: function () {
      // TODO: single provider can have multiple specialties
      return this.reportDesc.provider.specialties[0].name;
    },
    providerId: function () {
      return this.reportDesc.provider.id;
    },
  },
  methods: {
    getSpecialtyLink(specialty) {
      return specialty.toLowerCase().replace(/\s/g, '-');
    },
  },
  beforeDestroy() {
    delete this.reportDesc;
    delete this.providerFullName;
    delete this.providerSpecialty;
    delete this.providerId;
  }
}
</script>

<style scoped lang="scss">
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  table {
    font-size: 0.95em;
  }
  tr:nth-child(odd) {
    background-color: #d4d0d0;
  }
  td {
    padding: 0.5em;
  }

</style>